const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email) => EMAIL_REGEX.test((email || '').trim());

export const buildQuoteItems = (attentionsSelected) => (attentionsSelected || []).map((attention) => ({
    name: attention.medicalServiceName,
    count: attention.count || 1,
    unitPrice: attention?.needInputAmount && attention.amount ? attention.amount : (attention.needsToPay || 0),
}));
